import { render, staticRenderFns } from "./caption-carousel.vue?vue&type=template&id=561899a2&scoped=true&"
import script from "./caption-carousel.vue?vue&type=script&lang=js&"
export * from "./caption-carousel.vue?vue&type=script&lang=js&"
import style0 from "./caption-carousel.vue?vue&type=style&index=0&id=561899a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561899a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johndwells/Git/hys/penge-polls/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('561899a2')) {
      api.createRecord('561899a2', component.options)
    } else {
      api.reload('561899a2', component.options)
    }
    module.hot.accept("./caption-carousel.vue?vue&type=template&id=561899a2&scoped=true&", function () {
      api.rerender('561899a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vue/base/caption-carousel.vue"
export default component.exports